export enum EAdvancePaymentOnFutureHarvestScrollEventBlockId {
  financingOfferForm = 'financingOfferForm',
}
